import React from 'react';
import Loadable from 'react-loadable';

const LoadableWidget = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "SportsSportInPlayEventsWidget" */ './SportsSportInPlayEventsWidget'
    ),
  modules: ['./SportsSportInPlayEventsWidget'],
  loading: () => <div />
});

export default LoadableWidget;
